import React from 'react';
import { unwrap_arr } from '../utils';
import { colors } from '../styles';

const UpDown = ({
  active,
  chart_height,
  chart_width,
  max,
  round = true,
  spacing,
}) => {
  const past_was_better = unwrap_arr(active).raw === max;

  const h = 80;

  const paddingX = spacing;
  const paddingY = 10;

  const start = chart_width - 40 - paddingX;
  const end = chart_width - 80 - paddingX;

  const centerY = chart_height / 2;

  const down_points = `${chart_width - paddingX},${centerY + paddingY}  
                      ${start}, ${centerY + h} 
                    ${end},${centerY + paddingY}  
        `;

  const down = (
    <polygon
      points={down_points}
      fill={past_was_better ? colors.accent : colors.grey}
    />
  );

  const up_points = `${chart_width - paddingX},${centerY - paddingY}  
                            ${start}, ${centerY - h} 
                            ${end},${centerY - paddingY}  `;

  const up = (
    <polygon
      points={up_points}
      fill={!past_was_better ? colors.green : colors.grey}
    />
  );

  return (
    <g
      aria-hidden="true"
      strokeLinecap={round ? 'round' : 'square'}
      strokeLinejoin={round ? 'round' : 'miter'}
    >
      {up}
      {down}
    </g>
  );
};
export default UpDown;
